import { render, staticRenderFns } from "./OrgsManagement.vue?vue&type=template&id=ab8bd82a&scoped=true&"
import script from "./OrgsManagement.vue?vue&type=script&lang=js&"
export * from "./OrgsManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab8bd82a",
  null
  
)

export default component.exports